module.exports = __webpack_public_path__ + "static/media/testing_mocha.f5b292cd.png";